// The onboarding flashcard demo replays one real generation, with the waiting cut out.
// Source: flashcard job a2ecad8e (28 Sep 2026, AP Biology, 4 selected points, 16 cards, 50 sources, 41 s),
// deck 9e2d0cd8. points and coverage: verbatim from the AP Biology Course and Exam Description
// (src/data/apCourseHierarchies.generated/biology.json); coverage follows the deck's own coverage keys.
// showcase: card 7 of that deck, unedited. Replace only with another real generation.
export const FLASHCARD_DEMO = {
  "course": "AP Biology",
  "unit": "Unit 1: Chemistry of Life",
  "unitPoints": 25,
  "points": [
    {
      "code": "1.1.A",
      "type": "Learning Objective",
      "text": "Explain how the properties of water that result from its polarity and hydrogen bonding affect its biological function."
    },
    {
      "code": "1.1.A.1",
      "type": "Essential Knowledge",
      "text": "Living systems depend on the properties of water to sustain life. i. Water has polarity, because of the formation of polar covalent bonds between hydrogen and oxygen within water molecules. This polarity contributes to hydrogen bonding between and within biological molecules. ii. Water has a high specific heat capacity, which allows for the maintenance of homeostatic body temperature within living organisms. iii. Water has a high heat of vaporization, which allows for the evaporative cooling of the surrounding environment. In living organisms, this property allows for body temperature to be maintained."
    },
    {
      "code": "1.1.A.2",
      "type": "Essential Knowledge",
      "text": "The hydrogen bonds between adjacent polar water molecules result in cohesion, adhesion, and surface tension."
    },
    {
      "code": "1.2.A",
      "type": "Learning Objective",
      "text": "Describe the composition of macromolecules required by living organisms."
    }
  ],
  "coverage": [
    {
      "code": "1.1.A.1.i",
      "text": "Water has polarity, because of the formation of polar covalent bonds between hydrogen and oxygen within water molecules. This polarity contributes to hydrogen bonding between and within biological molecules."
    },
    {
      "code": "1.1.A.1.ii",
      "text": "Water has a high specific heat capacity, which allows for the maintenance of homeostatic body temperature within living organisms."
    },
    {
      "code": "1.1.A.1.iii",
      "text": "Water has a high heat of vaporization, which allows for the evaporative cooling of the surrounding environment. In living organisms, this property allows for body temperature to be maintained."
    },
    {
      "code": "1.1.A.2",
      "text": "The hydrogen bonds between adjacent polar water molecules result in cohesion, adhesion, and surface tension."
    },
    {
      "code": "1.2.A.1",
      "text": "Atoms and molecules from the environment are necessary to build new molecules. Carbon, hydrogen, and oxygen are the most prevalent elements used to build biological molecules such as carbohydrates, proteins, lipids, and nucleic acids. Additionally: i. Sulfur is used in the building of proteins. ii. Phosphorus is used in the building of phospholipids (a type of lipid) and nucleic acids. iii. Nitrogen is used in the building of nucleic"
    }
  ],
  "deck": {
    "topic": "Biology unit 3",
    "selectionCount": 4,
    "cardCount": 16,
    "sourceCount": 50,
    "showcase": {
      "front": "How does water’s high heat of vaporization enable evaporative cooling in living organisms?",
      "back": "Because hydrogen bonds between water molecules must be disrupted, vaporizing water requires a relatively large amount of energy. The highest-energy water molecules can escape from a moist surface during evaporation, carrying heat away from the organism’s surface. The remaining surface and organism cool, helping maintain body temperature; sweating is one example of this process.",
      "highlight": "Because hydrogen bonds between water molecules must be disrupted, vaporizing water requires a relatively large amount of energy."
    }
  }
};
